'use client';

import { ReactNode, useEffect } from 'react';

type AlertType = 'info' | 'success' | 'warning' | 'error';

const alertStyles: Record<AlertType, string> = {
  info: 'bg-blue-100 text-blue-700 border-blue-400',
  success: 'bg-green-100 text-green-700 border-green-400',
  warning: 'bg-yellow-100 text-yellow-700 border-yellow-400',
  error: 'bg-red-100 text-red-700 border-red-400',
};

export interface AlertProps {
  type: AlertType;
  message: ReactNode;
  close?(): void;
  timeout?: number;
}

export default function Alert({ type, message, close, timeout }: AlertProps) {
  useEffect(() => {
    if (timeout && close) {
      const id = setTimeout(close, timeout);
      return () => clearTimeout(id);
    }
  }, [timeout, close]);
  return (
    <div
      className={`relative rounded border-l-4 p-4 ${alertStyles[type]}`}
      role="alert"
    >
      <div className="text-sm text-current">{message}</div>
    </div>
  );
}
